/* eslint-disable */

<template>
  <div id="Lgx02714444011560346059001">
    <vue-sortable :options="options" @drag:start="startedDrag" @drag:stop="stoppedDrag" @sortable:sort="sort">
      <div class="vx-row" :class="{ 'cursor-drag': draggingCard === true }">
        <div class="vx-col lg:w-3/12 md:w-3/12 sm:w-5/5">
          <div class="bg-dark main-border rounded-lg mb-base">
            <h4 class="px-4 pb-3 pt-4 main-bottom-border">Relevant Findings</h4>

            <div class="flex flex-col items-between gap-2 p-4 main-bottom-border">
              <h4 class="self-center font-light" style="font-size: 14px">
                <span class="text-grey">
                  A natural disaster may disrupt operations at Site A, which would then cause an evacuation. Users are unable to login to
                  the domain from their workstations after relocating to Site B.
                </span>
              </h4>
              <div class="flex w-full mt-3 gap-x-3">
                <vue-draggable-container id="wb1" class="wbForensics" style="width: 9rem">
                  <h5 class="dragBlock cursor-pointer w-full" style="min-width: 4rem !important">1</h5>
                </vue-draggable-container>
              </div>
            </div>
            <div class="flex flex-col items-between gap-2 p-4 main-bottom-border">
              <h4 class="self-center font-light" style="font-size: 14px">
                <span class="text-grey">
                  A natural disaster may disrupt operations at Site A, which would then cause the pump room at Site B to become
                  inoperable.</span
                >
              </h4>
              <vue-draggable-container id="wb2" class="wbForensics" style="width: 9rem">
                <h5 class="dragBlock cursor-pointer w-full" style="min-width: 4rem !important">2</h5>
              </vue-draggable-container>
            </div>
            <div class="flex flex-col items-between gap-2 p-4">
              <h4 class="self-center font-light" style="font-size: 14px">
                <span class="text-grey">
                  A natural disaster may disrupt operations at Site A, which would then cause unreliable internet connectivity at Site B due
                  to route flapping.</span
                >
              </h4>
              <vue-draggable-container id="wb3" class="wbForensics" style="width: 9rem">
                <h5 class="dragBlock cursor-pointer w-full" style="min-width: 4rem !important">3</h5>
              </vue-draggable-container>

              <h2 class="mt-6" style="font-size: 16px">Corrective Action</h2>
              <v-select v-model="question.value" :options="questionOptions" class="w-full mt-1" placeholder="Select from Dropdown" />
              <small v-if="question.marked_score === false" class="ml-1 text-danger font-semibold">This answer is incorrect</small>
              <small v-if="question.marked_score === true" class="ml-1 text-success font-semibold">This answer is correct</small>
            </div>
          </div>
        </div>
        <div class="vx-col lg:w-9/12 md:w-9/12 sm:w-5/5">
          <vx-card class="mb-base">
            <div>
              <div class="vx-row">
                <div class="vx-col w-4/5 p-5 pt-2 rounded">
                  <div class="relative mb-3 main-border rounded-lg border-4 bg-light border-solid p-3 z-10">
                    <h2 class="font-bold p-2 rounded bg-success mb-4">Site A</h2>
                    <div class="grid grid-cols-3 gap-3">
                      <div
                        v-for="item in siteA"
                        :key="item.id"
                        class="flex flex-col justify-between items-center main-border bg-dark rounded-lg p-4"
                      >
                        <p class="flex text-center font-semibold mb-2">{{ item.name }}</p>
                        <vue-draggable-container class="dropzone dropzoneStandard answer-bg answerForensics w-full" :id="item.id" />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="vx-col w-1/5">
                  <div class="flex relative justify-center items-center align-middle h-full p-5">
                    <div class="rounded-full bg-light main-border z-10">
                      <lottie-animation
                        path="https://connect-cdn.intellectualpoint.com/assets/lotties/internet-rotate.json"
                        :loop="true"
                        :autoPlay="true"
                        :speed="1"
                        :width="150"
                      />
                    </div>
                    <div class="forensics-line-left"></div>
                    <div class="forensics-line-up"></div>
                  </div>
                </div>
              </div>

              <div class="vx-row">
                <div class="vx-col relative w-1/5">
                  <div class="forensics-line-rotate"></div>
                </div>

                <div class="vx-col w-4/5 p-5 rounded">
                  <div class="relative mb-3 main-border rounded-lg border-4 bg-light border-solid p-3 z-10">
                    <h2 class="font-bold p-2 rounded bg-primary mb-4">Site B</h2>
                    <div class="grid grid-cols-3 gap-4">
                      <div
                        v-for="item in siteB"
                        :key="item.id"
                        class="flex flex-col justify-between items-center main-border bg-dark rounded-lg p-4"
                      >
                        <p class="flex text-center font-semibold mb-2">{{ item.name }}</p>
                        <vue-draggable-container class="dropzone dropzoneStandard answer-bg answerForensics w-full" :id="item.id" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </vue-sortable>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import Prism from 'vue-prism-component';
import vSelect from 'vue-select';
import LottieAnimation from '../../../../../../../../components/lottie/LottieAnimation';
import shuffle from 'shuffle-array';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,

      options: {
        draggable: '.dragBlock',
        dropzone: '.dropzoneStandard',
      },

      questionOptions: [
        'Modify the BGP configuration',
        'Update the firmware version',
        'Increase the bandwidth at the site',
        'Implement AV software',
        'Update the SCADA Master Controller software',
        'Synchronize the SIEM database',
        'Integrate a WAF',
      ],

      question: {
        answer: 'Modify the BGP configuration',
        value: '',
        marked_score: null,
      },

      siteA: [
        {
          name: 'HVAC',
          id: 'aInputHVAC',
        },
        {
          name: 'PLC',
          id: 'aInputPLC',
        },
        {
          name: 'PLC',
          id: 'aInputPLC2',
        },
        {
          name: 'Pumps',
          id: 'aInputPumps',
        },
        {
          name: 'Application Server 01',
          id: 'aInputAs01',
        },
        {
          name: 'SCADA Master Controller',
          id: 'aInputSCADA',
        },
        {
          name: 'Directory Server',
          id: 'aInputDs',
        },
        {
          name: 'Web Server 01',
          id: 'aInputWs01',
        },
        {
          name: 'Application Server 02',
          id: 'aInputAs02',
        },
        {
          name: 'VPN Concentrator',
          id: 'aInputVpnC',
        },
      ],

      siteB: [
        {
          name: 'VPN Concentrator',
          id: 'bInputVpnC',
        },
        {
          name: 'Application Server 03',
          id: 'bInputAs03',
        },
        {
          name: 'Application Server 04',
          id: 'bInputAs04',
        },
        {
          name: 'File Server',
          id: 'bInputFs',
        },
        {
          name: 'PLC',
          id: 'bInputPLC',
        },
        {
          name: 'Pumps',
          id: 'bInputPumps',
        },
      ],
    };
  },
  methods: {
    startedDrag(x) {
      x.data.source.className += ' currently-dragging-standard';
      this.draggingCard = true;
    },
    stoppedDrag() {
      this.draggingCard = false;
    },
    sort(x) {
      const overContainer = x.data.dragEvent.data.overContainer;
      const origSourceContainer = x.data.dragEvent.data.originalSource;
      if (overContainer.classList.contains('wbForensics')) {
        if (overContainer.children.length > 0) {
          return x.cancel();
        }
      }
      if (overContainer && overContainer.classList.contains('dropzone')) {
        const id = origSourceContainer.id;
        document.getElementById(`${id}-cloned`).style.display = 'inline-flex';
        document.getElementById(id).classList.remove('dragBlock');
        document.getElementById(id).classList.add('stillBlockForensicsClassification');
        return;
      }
      document.getElementById(`${origSourceContainer.id}-cloned`).outerHTML = '';
    },
    markSimulation() {
      let totalScore = 0;

      if (document.getElementById('aInputDs').textContent === '1') {
        document.getElementById('aInputDs').style.borderColor = '#28C76F';
        totalScore++;
      }

      if (document.getElementById('aInputSCADA').textContent === '2') {
        document.getElementById('aInputSCADA').style.borderColor = '#28C76F';
        totalScore++;
      }

      if (document.getElementById('aInputVpnC').textContent === '3') {
        document.getElementById('aInputVpnC').style.borderColor = '#28C76F';
        totalScore++;
      }

      if (this.question.value === this.question.answer) {
        this.question.marked_score = true;
        totalScore++;
      } else {
        this.question.marked_score = false;
      }

      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore);
      }

      this.$emit('simulation_getting_there', totalScore);
    },
  },
  components: {
    draggable,
    Prism,
    vSelect,
    LottieAnimation,
    shuffle,
  },
  created() {
    this.siteA = shuffle(this.siteA);
    this.siteB = shuffle(this.siteB);
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style lang="scss">
.stillBlockForensicsClassification {
  padding: 12px;
  word-break: break-all;
  background-color: rgba(var(--vs-primary), 1);
  display: inline-flex;
  margin: 5px;
  border-radius: 5px;
  font-size: 1.4rem;
  text-align: center;
  justify-content: center;
  align-items: center;
  z-index: 999999999999 !important;
  border: 0.18rem solid transparent;
  font-weight: 800 !important;
  cursor: url('~@/assets/images/cursor/trash-cursor.png'), auto !important;
  background-color: #ffd900;
  color: #000000 !important;
}

#Lgx02714444011560346059001 {
  .forensics-line-up {
    position: absolute;
    left: auto;
    right: auto;
    width: 6px;
    height: 380px;
    bottom: -2rem;
    z-index: 0;
    background-color: #0053ff;
  }
  .forensics-line-left {
    position: absolute;
    width: 6vw;
    height: 6px;
    margin-right: 6vw;
    z-index: 0;
    background-color: #0053ff;
  }
  .forensics-line-rotate {
    position: absolute;
    width: 11.5vw;
    height: 6px;
    z-index: 0;
    background-color: #0053ff;
    -webkit-transform: rotate(30deg);
    -ms-transform: rotate(30deg);
    transform: rotate(30deg);
  }
  .wbForensics {
    min-height: 55px;
    border-radius: 0.6rem;
    padding: 0.4rem;
    justify-content: center;
    background-color: #040915;
    border: 1px solid #181d2a;
    display: flex;
  }
  .dataForensicsDragBlock {
    min-width: 50px !important;
    background-color: #ffd900;
    color: #000000 !important;
    font-weight: 800 !important;
  }

  .dataForensicsBlock {
    border-color: #ffffff;
    border-style: solid;
    border-width: 2px 0 0 0;
    padding: 7px 0 7px 0;
  }

  .answerForensics {
    min-height: 47.5px;
  }
}
</style>
